<template>
  <sweet-modal :title="$t('settings_COA') + ' - ' + (state === 'create' ? $t('settings_addAccount') : $t('settings_editAccount'))" blocking ref="modal" class="modal" v-on:close="close">
    <el-form :model="form" ref="form" status-icon :rules="rules" label-position="left">
      <el-form-item prop="dbCode">
        <el-input v-if="state !== 'create'" readonly :label="$t('settings_accountThink_GLAccounts_dbCode')" v-model="form.dbCode"></el-input>
      </el-form-item>
      <el-form-item prop="number">
        <el-input :label="$t('settings_accountThink_GLAccounts_accNo')" v-model="form.number"></el-input>
      </el-form-item>
      <el-form-item prop="type">
        <el-input
            readonly
            :label="$t('settings_accountThink_GLAccounts_(type)')"
            v-model="type.name">
        </el-input>
      </el-form-item>
      <el-form-item prop="class">
        <el-input
            readonly
            :label="$t('settings_accountThink_GLAccounts_(class)')"
            v-model="myClass.name">
        </el-input>
      </el-form-item>
      <el-form-item prop="group">
        <el-input
            readonly
            :label="$t('settings_accountThink_GLAccounts_(group)')"
            v-model="group.name">
        </el-input>
      </el-form-item>
      <el-form-item prop="name">
        <el-autocomplete
            :label="$t('settings_accountThink_GLAccounts_(account)')"
            :fetch-suggestions="querySearch"
            value-key="name"
            v-model="form.name">
        </el-autocomplete>
      </el-form-item>
      <el-form-item label-width="100px" prop="DRCRCode" style="margin-bottom: 0;" :label="$t('settings_accountThink_GLAccounts_setAs')">
        <el-radio-group v-model="form.DRCRCode" size="small" disabled>
          <el-radio label="DR"  border style="margin-right: 0;">DR</el-radio>
          <el-radio label="CR" border>CR</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label-width="100px" prop="accountType" style="margin-bottom: 0;" label="Account Type">
        <el-radio-group :disabled="state === 'update'" v-model="form.accountType">
          <el-radio :label="1">Default Account</el-radio>
          <el-radio :label="2">Tax Account</el-radio>
          <el-radio v-if="isBankAccountAvailable" :label="3">Bank Account</el-radio>
          <el-radio v-if="isCreditCardAccountAvailable" :label="4">Credit Card Account</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-card v-if="form.accountType === 2">
        <el-form-item label-width="100px" size="mini" prop="taxTypeId" :label="$t('modal_taxLibraries')">
          <el-select v-model="form.taxTypeId" :placeholder="$t('modal_taxLibraries')" style="width: 300px;" @change="handleSelectTaxType">
            <el-option
                v-for="type in taxTypes"
                :key="type.id"
                :label="type.name"
                :value="type.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="100px" size="mini" prop="taxId" :label="$t('modal_taxCode')">
          <el-select :disabled="!form.taxTypeId" v-model="form.taxId" :placeholder="$t('modal_taxCode')" style="width: 300px;">
            <el-option
                v-for="type in taxes"
                :key="type.id"
                :label="type.name"
                :value="type.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-card>
      <el-form-item label-width="100px" prop="accountCurrencyId" label="Currency">
        <el-select v-model="form.accountCurrencyId" no-data-text="no date" placeholder="Currency" filterable>
          <el-option
              v-for="item in currencyList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="100px" prop="accountId" label="Account Tax">
        <el-select v-model="form.accountId" no-data-text="no date" placeholder="Not Assigned" filterable>
          <el-option
              v-for="item in accounts"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="100px" prop="clashflowId" style="margin-bottom: 0;" label="Cash Flow">
        <el-select v-model="form.clashflowId" no-data-text="no date" placeholder="Cash Flow" filterable clearable>
          <el-option
              v-for="item in cashFlowList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="modal__btn" style="float:right;">
        <el-button v-if="state === 'create'" @click="create('form')" type="primary">{{$t('general_add')}}</el-button>
        <el-button v-else @click="update('form')" type="primary">{{$t('general_update')}}</el-button>
      </el-form-item>
    </el-form>
  </sweet-modal>
</template>

<script>
import axios from 'axios'
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
export default {
  name: "COAAddAccountModal",
  props: {
    currencyList: {
      type: Array,
      default: () => ([])
    },
    rowData: {
      type: Array,
      default: () => ([])
    },
    cashFlowList: {
      type: Array,
      default: () => ([])
    },
    accountsNamesList: {
      type: Array,
      default: () => ([])
    },
    accounts: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
    isBankAccountAvailable() {
      return this.group.code.length && this.group.code[0] === '1'
    },
    isCreditCardAccountAvailable() {
      return this.group.code.length && this.group.code[0] === '2'
    }
  },
  data() {
    return {
      state: 'create',
      form: {
        dbCode: null,
        number: null,
        name: null,
        DRCRCode: 'CR',
        isBankAccount: false,
        clashflowId: null,
        accountType: 1,
        taxTypeId: null,
        taxId: null,
        // makeInactive: false,
        groupId: null,
        parentId: null,
        filePath: [],
        accountCurrencyId: null,
        accountId: null
      },
      rules: {
        name: [
          { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'change' }
        ],
        taxTypeId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ],
        taxId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ],
        accountId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ],
        clashflowId: [
          { required: true, message: 'Field is required', trigger: 'change' }
        ]
      },
      type: {},
      myClass: {},
      group: {
        code: ''
      },
      taxTypes: [
        { id: 1, name: this.$t('settings_accountThink_taxTypes_taxes') },
        { id: 2, name: this.$t('settings_accountThink_taxTypes_withholdingTaxes') }
      ],
      taxes: [],
      params: {
        data:{
          taxId: null
        }
      },
      // cashFlowList: ['Operating', 'Investing', 'Financing']
    }
  },
  components: {
    SweetModal
  },
  methods: {
    openModal(state, params) {
      this.params = params
      console.log('params---', params)
      if (this.companyLayout.currency) this.form.accountCurrencyId = this.companyLayout.currency.id
      if (params.node.data.entityType === 'group') {
        this.form.groupId = params.node.data.id
        this.form.parentId = null
        this.form.filePath = params.node.data.filePath
        this.form.DRCRCode = params.node.data.DRCRCode
        this.group = params.node.data
        this.form.clashflowId = params.node.data.clashflowId ? params.node.data.clashflowId : null

        params.api.forEachNode((node, index) => {
          if (node.data.id === params.node.data.classId && node.data.entityType === 'class') {
            this.myClass = node.data
            params.api.forEachNode((node2, index2) => {
              if (node2.data.id === this.myClass.typeId && node2.data.entityType === 'type') {
                this.type = node2.data
              }
            })
          }
        })
      }

      if (params.node.data.entityType === 'account') {
        this.form.groupId = params.node.data.groupId
        this.form.DRCRCode = params.node.data.DRCRCode
        this.form.parentId = null
        params.api.forEachNode((node) => {
          if (node.data.id === params.node.data.groupId && node.data.entityType === 'group') {
            this.group = node.data
            this.form.filePath = node.data.filePath
            this.form.clashflowId = node.data.clashflowId ? node.data.clashflowId : null
            params.api.forEachNode((node1) => {
              if (node1.data.id === this.group.classId && node1.data.entityType === 'class') {
                this.myClass = node1.data
                params.api.forEachNode((node2) => {
                  if (node2.data.id === this.myClass.typeId && node2.data.entityType === 'type') {
                    this.type = node2.data
                  }
                })
              }
            })
          }
        })
      }

      if (params.node.data.entityType === 'folder') {
        this.form.groupId = params.node.data.groupId
        this.form.DRCRCode = params.node.data.DRCRCode
        this.form.parentId = params.node.data.filePath[params.node.data.filePath.length - 1]
        this.form.filePath = params.node.data.filePath
        this.form.clashflowId = params.node.data.clashflowId ? params.node.data.clashflowId : null
        this.type = this.rowData.find(bal => bal.id === params.node.data.filePath[0] && bal.entityType === 'type')
        this.myClass = this.rowData.find(bal => bal.id === params.node.data.filePath[1] && bal.entityType === 'class')
        this.group = this.rowData.find(bal => bal.id === params.node.data.filePath[2] && bal.entityType === 'group')
      }

      this.state = state
      this.$refs.modal.open()
      console.log('open modal', state)
    },
    async openModalEdit(state, params) {
      this.params = params
      this.form.accountCurrencyId = params.node.data.accountCurrencyId ? params.node.data.accountCurrencyId : params.node.data.currencyId
      this.form.groupId = params.node.data.groupId
      this.form.DRCRCode = params.node.data.DRCRCode
      this.form.parentId = params.node.data.parentId
      this.form.name = params.node.data.name
      this.form.number = params.node.data.number
      this.form.dbCode = params.node.data.code
      this.form.isBankAccount = params.node.data.isBankAccount
      // this.form.makeInactive = !params.node.data.active
      this.form.clashflowId = params.node.data.clashflowId
      if (params.node.data.assignToTaxAccountId) {
        this.form.accountId = params.node.data.assignToTaxAccountId
      }
      if (params.node.data.taxId) {
        this.form.taxId = params.node.data.taxId
        this.form.taxTypeId = params.node.data.taxTypeId
        await this.handleSelectTaxType(this.form.taxTypeId, true)
        this.form.accountType = 2
      } else if (params.node.data.isBankAccount) {
        this.form.accountType = 3
      } else if (params.node.data.isCreditCardAccount) {
        this.form.accountType = 4
      }


      params.api.forEachNode((node) => {
        if (node.data.id === params.node.data.groupId && node.data.entityType === 'group') {
          this.group = node.data
          this.form.filePath = node.data.filePath
          params.api.forEachNode((node1) => {
            if (node1.data.id === this.group.classId && node1.data.entityType === 'class') {
              this.myClass = node1.data
              params.api.forEachNode((node2) => {
                if (node2.data.id === this.myClass.typeId && node2.data.entityType === 'type') {
                  this.type = node2.data
                }
              })
            }
          })
        }
      })
      this.state = state
      this.$refs.modal.open()
    },
    create(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          const payload = {
            groupId: this.form.groupId,
            parentId: this.form.parentId,
            filePath: this.form.filePath,
            clashflowId: this.form.clashflowId,
            name: this.form.name,
            number: this.form.number,
            // active: !this.form.makeInactive,
            accountCurrencyId: this.form.accountCurrencyId,
            isBankAccount: this.form.accountType === 3,
            isCreditCardAccount: this.form.accountType === 4,
            type: 'account'
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/account/create?companyId=${this.$route.query.companyId}`, payload)
              .then(async response => {
                try {
                  if (this.form.accountType === 2) {
                    await this.createTaxAccount(response.data.id)
                  }
                  if (this.form.accountId) {
                    await this.assignTax(response.data.id)
                  }
                  console.log('response', response.data);
                  this.notification(this.$t('general_success'), this.$t('setting_accountCreated'), "success");
                  this.$emit('loadList', { entityType: response.data.entityType, id: response.data.id })
                  loader.hide()
                  this.$refs.modal.close()
                } catch (err) {
                  console.log(err)
                }
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              })
        }
      })
    },
    async assignTax(accountId) {
      try {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.get(`/api/v1/account/assignAccountToTaxAccount?accountId=${accountId}&assignToTaxAccountId=${this.form.accountId}`)
        loader.hide()
      } catch (err) {
        console.log(err)
      }
    },
    createTaxAccount(accountId) {
      return new Promise ((resolve) => {
        const payload = {
          taxTypeId: this.form.taxTypeId,
          taxId: this.form.taxId
        }
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/account/addTax?accountId=${accountId}`, payload).then(response => {
          console.log(response)
          loader.hide()
          resolve(response)
          // this.notification(this.$t('modal_settings_success'), this.$t('modal_settings_taxSuccessfullyCreated'), "success")
          // this.$refs.modal.close()
          // loader.hide()
          // this.$emit('loadList', { entityType: 'account', id: this.params.data.id })
        }).catch(err => {
          console.log(err)
          loader.hide()
        })
      })
    },
    update(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          const payload = {
            name: this.form.name,
            number: this.form.number,
            clashflowId: this.form.clashflowId,
            isBankAccount: this.form.accountType === 3,
            isCreditCardAccount: this.form.accountType === 4,
            // active: !this.form.makeInactive,
            accountCurrencyId: this.form.accountCurrencyId
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/account/update?accountId=${this.params.node.data.id}`, payload)
              .then(async response => {
                try {
                  if (this.form.accountType === 2) {
                    await this.createTaxAccount(this.params.node.data.id)
                  }
                  if (this.form.accountId) {
                    await this.assignTax(this.params.node.data.id)
                  }
                  console.log('response', response.data);
                  this.notification(this.$t('general_success'), this.$t('setting_accountUpdated'), "success");
                  this.$emit('loadList', { entityType: 'account', id: this.params.node.data.id })
                  loader.hide()
                  this.$refs.modal.close()
                } catch (err) {
                  console.log(err)
                }
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              })
        }
      })
    },
    async handleSelectTaxType(type, dontRemoveTax) {
      if (!dontRemoveTax) this.form.taxId = null
      this.taxes = []
      let url = ''
      switch (type) {
        case 1:
          url = `/api/v1/projectTaxes/list?companyId=${this.$route.query.companyId}`
          break;
        case 2:
          url = `/api/v1/withholdingTaxes/list?companyId=${this.$route.query.companyId}`
          break;
      }
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      try {
        const response = await axios.post(url)
        this.taxes = response.data.list
        loader.hide()
      } catch (err) {
        loader.hide()
      }
    },
    close() {
      this.state = 'create'
      this.form.dbCode = null
      // this.form.type = null
      this.form.DRCRCode = 'CR'
      this.form.accountCurrencyId = null
      // this.form.classId = null
      this.form.parentId = null
      this.form.filePath = []
      this.form.name = null
      this.form.number = null
      this.form.taxTypeId = null
      this.form.taxId = null
      this.form.accountId = null
      this.form.accountType = 1
      this.form.clashflowId = null
      this.form.isBankAccount = false
      this.taxes = []
      // this.form.makeInactive = false
      this.params = {
        data:{
          taxId: null
        }
      }
      this.type = {}
      this.myClass = {}
      this.group = {
        code: ''
      }
      this.$refs['form'].resetFields()
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    querySearch(queryString, cb) {
      let links = this.accountsNamesList;
      let results = queryString ? links.filter(this.createFilter(queryString)) : links;
      console.log(results)
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return (link) => {
        return (link.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      }
    },
    handleSelect(item) {
      console.log(item);
    }
  }
}
</script>

<style scoped>

</style>
